'use strict';

import React from 'react';
import PropTypes from 'prop-types';
import { cn } from '@src/utils/ui';
import { ServiceBadge } from '../service-badge/service-badge';

export const TopRatedBadge = ({ className = '' }) => {
    return (
        <ServiceBadge
            className={cn(
                'tw-gap-[4px] tw-flex tw-items-center tw-text-white tw-bg-bcaa-green-go tw-rounded-[4px]',
                className
            )}
        >
            <span className='tw-text-[12px] tw-font-[700] tw-italic'>Top Rated</span>
        </ServiceBadge>
    );
};

TopRatedBadge.propTypes = {
    className: PropTypes.string
};
